import React, { useMemo } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import {
  ThemeProvider,
  CssBaseline,
  Stack,
  CircularProgress,
  Typography,
} from "@mui/material";
import { SettingsProvider, useSettings } from "components/settings";
import { setupApp } from "./setup";
import createTheme from "./theme";

const Shell = React.lazy(() =>
  import(/* webpackChunkName: "shell" */ "./pages/Shell")
);

const ShellLoader = () => (
  <Stack alignItems="center" spacing={2} mt={10}>
    <Typography>Loading Cinnamon MUI Docs...</Typography>
    <CircularProgress />
  </Stack>
);

const ThemedShell = () => {
  const { darkMode } = useSettings();
  const theme = useMemo(
    () => createTheme(darkMode ? "dark" : "light"),
    [darkMode]
  );
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <React.Suspense fallback={<ShellLoader />}>
        <Shell />
      </React.Suspense>
    </ThemeProvider>
  );
};

const { store } = setupApp();

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <SettingsProvider>
        <ThemedShell />
      </SettingsProvider>
    </BrowserRouter>
  </Provider>
);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
